let API_URL = '';
let uploadurl = '';
if (process.env.NODE_ENV === 'development') {
    API_URL = process.env.VUE_APP_DEV_API_URL;
    uploadurl = process.env.VUE_APP_UPLOAD_URL;
} else {
    API_URL = process.env.VUE_APP_API_URL;
    uploadurl = process.env.VUE_APP_PROD_UPLOAD_URL;
}
export const BACKEND = API_URL;
export const UPLOAD_URL = uploadurl;